const amountIconTable = () => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: {
      icons: "@",
    },
    link: (scope) => {
      scope.iconsArr = scope.icons.split(/[\s\n]/);
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountIconTable", amountIconTable);
